<script lang="ts" context="module">
  export const invoiceErrorModal = new ModalQueryState('invoice-error');
</script>

<script lang="ts">
  import Close from '~icons/mdi/close';
  import ActionButton from '~/components/ActionButton.svelte';
  import Modal from '~/components/Modal.svelte';
  import { ModalQueryState } from '~/lib/nav.svelte';
  import { getSubscriptionQuery } from './mutations.svelte';
  import ManageSubscription from './ManageSubscription.svelte';
  import AlertTriangleIcon from '~icons/feather/alert-triangle';
  import type Stripe from 'stripe';
  import StatusText from '~/components/StatusText.svelte';

  const sub = getSubscriptionQuery();

  const handleClose = () => {
    invoiceErrorModal.pop();
  };

  const statusToString = (status?: Stripe.Subscription.Status) => {
    switch (status) {
      case 'incomplete':
        return 'A successful payment needs to be made within 23 hours to activate your subscription';
      case 'incomplete_expired':
        return 'The initial payment on the subscription failed and no successful payment was made within 23 hours of creating the subscription.';
      case 'past_due':
        return 'The invoice is past due.';
      case 'canceled':
        return 'The subscription has been canceled.';
      case 'unpaid':
        return 'The latest invoice hasn’t been paid.';
      case 'paused':
        return 'The subscription has ended its trial period without a default payment method.';
      default:
        return 'There was an error. Reach out to support@gramjam.app for help.';
    }
  };
</script>

<Modal open={invoiceErrorModal.open} onClose={handleClose} index={7}>
  {#snippet title()}
    <AlertTriangleIcon size="48" /> There is an error with your subscription
  {/snippet}
  {#snippet content()}
    <StatusText status="warn">{statusToString(sub.data?.status)}</StatusText>
    <ManageSubscription />
  {/snippet}
  {#snippet controls()}
    <ActionButton onClick={handleClose}><Close />Close</ActionButton>
  {/snippet}
</Modal>
